module.exports = __webpack_public_path__ + "front/img/edm-bj-xianshang.18c31b5e.png";